



















import Vue, { PropType } from 'vue';

import { v4 } from 'uuid';
const generateListKey = () => v4();

// type InnerItem = {
//   id: string;
//   value: any;
// }

// type DataType = {
//   id: string
// }

export default Vue.extend({
  name: 'GMovableLayoutBox',
  data() {
    return {
      id: generateListKey(),
    };
  },
  props: {
    list: { type: Array as PropType<any>, required: true },
    index: { type: Number as PropType<number>, required: true },
    heading: { type: String as PropType<string> },
    isHidden: { type: Boolean as PropType<boolean>, default: false },
    // onDelete: { type: Function as PropType<Function>, required: true },
    // onUp: { type: Function as PropType<Function>, required: true },
    // onDown: { type: Function as PropType<Function>, required: true },
  },
  computed: {
    innerValue(): any {
      return this.list[this.index];
    },
  },

  // computed: {
  //   innerList: {
  //     get(): InnerItem[] {
  //       const ls = [];
  //       for (const o of this.list) {
  //         ls.push({
  //           id: generateListKey(),
  //           value: o,
  //         });
  //       }
  //       return ls;
  //     },
  //     set(val: InnerItem[]) {
  //       this.list = val.map((o) => o.value);
  //     },
  //   },
  // },
  methods: {
    onDelete(): void {
      const list = this.list;
      const index = this.index;
      list.splice(index, 1);
    },
    onUp(): void {
      const list = this.list;
      const index = this.index;
      if (index === 0) return;
      const val = list.slice(index, index + 1);
      list.splice(index, 1);
      list.splice(index - 1, 0, val[0]);
    },
    onDown(): void {
      const list = this.list;
      const index = this.index;
      if (index >= list.length - 1) return;
      const val = list.slice(index, index + 1);
      list.splice(index, 1);
      list.splice(index + 1, 0, val[0]);
    },
  },
});
